import { SET_ICONS } from "../types/iconsTypes"

const initialState = {
  all: [],
};

const iconsRedcuer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ICONS:
      return { ...state, all: action.payload };
    default:
      return state;
  }
}

export default iconsRedcuer